var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6733 0.240705C15.0763 0.589172 15.1113 1.18805 14.7515 1.57834L5.43469 11.6836C5.24908 11.8849 4.98365 12 4.70498 12C4.4263 12 4.16085 11.8849 3.97526 11.6836L0.248543 7.64148C-0.111287 7.25116 -0.0762778 6.6523 0.326739 6.3038C0.729743 5.95542 1.34816 5.98927 1.70799 6.37958L4.70498 9.63019L13.2921 0.316419C13.6518 -0.073871 14.2702 -0.107774 14.6733 0.240705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tick_mark.5121758c5f584c6f62d89bb752eb3c73.svg";
export { ForwardRef as ReactComponent };